import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import {
  ActionIcon,
  Button,
  Divider,
  Group,
  ScrollArea,
  Select,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useListState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconX } from "@tabler/icons-react";
import { useState } from "react";
import {
  RegisterCustomTeamsInput,
  TournamentTeamStatus,
} from "../../../../../gql/graphql";
import { PlayerSearch } from "../../../components/form/PlayerSearch";

export const CreateTeamModal = ({ tournamentId }: { tournamentId: string }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [tag, setTag] = useState("");
  const [status, setStatus] = useState<TournamentTeamStatus>(
    TournamentTeamStatus.Registered,
  );
  const [members, { append, filter }] = useListState<{
    playerProfileId: string;
    username: string;
  }>([]);
  const [registerCustomTournamentTeams] = useMutation<
    {
      registerCustomTournamentTeams: { id: string };
    },
    { tournamentId: string; input: RegisterCustomTeamsInput }
  >(gql`
    mutation ($tournamentId: ID!, $input: RegisterCustomTeamsInput!) {
      registerCustomTournamentTeams(
        tournamentId: $tournamentId
        input: $input
      ) {
        id
      }
    }
  `);

  return (
    <Stack>
      <TextInput
        label="Name"
        value={name}
        onChange={(event) => setName(event.currentTarget.value)}
      />
      <TextInput
        label="Tag"
        value={tag}
        onChange={(event) => setTag(event.currentTarget.value)}
      />
      <Select
        label="Status"
        value={status}
        onChange={(value) => setStatus(value as TournamentTeamStatus)}
        data={Object.values(TournamentTeamStatus)}
      />
      <Divider />
      <Text size="lg" fw={700}>
        Members
      </Text>
      <ScrollArea mah={200}>
        {members.map((member) => (
          <Group key={member.playerProfileId}>
            {member.username}
            <ActionIcon
              onClick={() =>
                filter((m) => m.playerProfileId !== member.playerProfileId)
              }
              variant="transparent"
              color="red"
            >
              <IconX />
            </ActionIcon>
          </Group>
        ))}
      </ScrollArea>
      <PlayerSearch
        onChange={(player) => {
          if (members.find((m) => m.playerProfileId === player.id)) {
            return;
          }
          append({
            playerProfileId: player.id,
            username: player.username,
          });
        }}
      />
      <Button
        loading={loading}
        onClick={() => {
          setLoading(true);
          registerCustomTournamentTeams({
            variables: {
              tournamentId,
              input: {
                customTeams: [
                  {
                    name: name,
                    tag: tag,
                    status: status,
                    members: members.map((m) => ({
                      playerId: m.playerProfileId,
                    })),
                  },
                ],
              },
            },
          })
            .then((data) => {
              if (data?.error) {
                throw new Error(data.error.message);
              }
              modals.closeAll();
            })
            .finally(() => {
              setLoading(false);
            });
        }}
      >
        Register
      </Button>
    </Stack>
  );
};
